import { addDays, differenceInCalendarDays } from 'date-fns';

export const getTimeFromPastDate = (date: Date) => {
  return addDays(date, differenceInCalendarDays(new Date(), date));
};
